"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  props: ['ircinput'],
  computed: {
    emojis() {
      let list = {};
      let available = this.$state.setting('emojis');
      _lodash.default.each(available, (code, ascii) => {
        if (!code) {
          // Emoji has an empty value, skip
          return;
        }
        list[code] = ascii;
      });
      return list;
    },
    location() {
      return this.$state.setting('emojiLocation');
    }
  },
  methods: {
    onImgClick: function onImgClick(event) {
      let url = window.getComputedStyle(event.target, null).getPropertyValue('background-image');
      url = Misc.extractURL(url);
      let code = event.target.dataset.code;
      this.ircinput.addImg(code, url);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["Emoji"]
window._kiwi_exports.components.inputtools.Emoji = exports.default ? exports.default : exports;
